export enum LoggerType {
  CONSOLE = 'console',
}
